import React, { useEffect } from 'react';
import { Link,Outlet, useLocation } from 'react-router-dom'; 
import {  useSelector } from 'react-redux';
import UserHeader from "../layouts/UserHeader"
import UserFooter from "../layouts/UserFooter"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GlobalSearch from '../components/Products/GlobalSearch';
import paths from '../routes/paths';
import LoginModal from '../components/Auth/LoginModal'
const MainLayout = () => {
  const {  pathname } = useLocation();
  const {isGlobalSearchOpen} = useSelector((state:any) => state.common)
  const {loggedInUser,loginModalShow} = useSelector((state:any) => state.auth)


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
  <> 
    {loggedInUser !== null  && loggedInUser?.loginType === 'Admin' && <Link to={paths.adminDashboard} className='btn btn-secondary btn-small'>Go to Dashboard</Link>}
    {((loggedInUser !== null  && loggedInUser?.loginType === 'Customer') || loggedInUser === null ) && (
      <div className="page-wraper">
     
          <UserHeader/>
          {isGlobalSearchOpen && <GlobalSearch />}
          {!isGlobalSearchOpen && <Outlet />}
          
          <UserFooter/>
          { loginModalShow && loggedInUser === null && <LoginModal />}

          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            draggable
            theme="dark"
            />

      </div>
    )}
 
 </>
       
  );
};

export default MainLayout;
